module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-noneheader"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [(this.$route.query.customerId) ? [_c('el-breadcrumb-item', [_vm._v("客户管理")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/customer/customerEmpList'
      }
    }
  }, [_vm._v("我的客户")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("服务提醒")])] : [_c('el-breadcrumb-item', [_vm._v("客户管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("服务提醒")])]], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "min-height": "80%"
    }
  }, [_c('div', {
    staticClass: "search-div"
  }, [(_vm.customerId == null) ? [_c('el-input', {
    staticClass: "input-size-200 input-margin-right",
    attrs: {
      "placeholder": "请输创建用户昵称"
    },
    model: {
      value: (_vm.createName),
      callback: function($$v) {
        _vm.createName = $$v
      },
      expression: "createName"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "input-size-200 input-margin-right",
    attrs: {
      "placeholder": "请输入客户姓名"
    },
    model: {
      value: (_vm.infoName),
      callback: function($$v) {
        _vm.infoName = $$v
      },
      expression: "infoName"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "input-size-200 input-margin-right",
    attrs: {
      "placeholder": "请输服务用户昵称"
    },
    model: {
      value: (_vm.toName),
      callback: function($$v) {
        _vm.toName = $$v
      },
      expression: "toName"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "input-size-200 input-margin-right",
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择开始日期"
    },
    model: {
      value: (_vm.beginAt),
      callback: function($$v) {
        _vm.beginAt = $$v
      },
      expression: "beginAt"
    }
  })] : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "button-pull-right",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "success",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        return _vm.handleCreate()
      }
    }
  }, [_vm._v("新增\n            ")]), _vm._v(" "), (_vm.customerId == null) ? [_c('el-button', {
    staticClass: "button-pull-right",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("搜索\n              ")])] : _vm._e(), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dt.data,
      "stripe": true,
      "border": "",
      "highlight-current-row": "",
      "size": _vm.dt.size
    },
    on: {
      "sort-change": _vm.dt.handleSortChange,
      "selection-change": _vm.dt.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "5%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "id",
      "label": "ID",
      "min-width": "5%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "customerInfo.name",
      "label": "服务客户名称",
      "min-width": "10%",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "toUser.name",
      "label": "服务系统用户昵称",
      "min-width": "10%",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "remark",
      "label": "备注",
      "min-width": "20%",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "beginAt",
      "formatter": _vm.dateFormat,
      "label": "开始日期",
      "min-width": "10%",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "endAt",
      "formatter": _vm.dateFormat,
      "label": "结束日期",
      "min-width": "10%",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "commonStatus",
      "label": "状态",
      "min-width": "10%",
      "sortable": "custom",
      "formatter": _vm.commonStatusFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "createUser.staffName",
      "label": "创建用户",
      "min-width": "10%",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "loopType",
      "label": "是否重复",
      "min-width": "10%",
      "sortable": "custom",
      "formatter": _vm.booleanFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "loopInterval",
      "label": "间隔",
      "min-width": "10%",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "20%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.commonStatus === 'EFFECTIVE') ? [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑\n                ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger",
            "plain": true
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_vm._v("刪除\n                ")])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.dt.currentPage,
      "page-sizes": _vm.dt.pageSizes,
      "page-size": _vm.dt.pageSize,
      "layout": _vm.dt.layout,
      "total": _vm.dt.totalElements
    },
    on: {
      "size-change": _vm.dt.handleSizeChange,
      "current-change": _vm.dt.handleCurrentChange
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3642823e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/memo/SystemMemoList.vue
// module id = 451
// module chunks = 2